import { useMutation } from '@tanstack/react-query'
import { postCreatePayment } from 'services/PaymentsService'

export const useCreatePaymentMutation = () => {
  return useMutation({ mutationFn: postCreatePayment })
}
